import { Controller } from "@hotwired/stimulus"

// Enter sends the chat message; Shift+Enter inserts a newline. Cmd/Ctrl+Enter
// also sends, for anyone used to the old shortcut. Wired via data-action on
// the textarea in app/views/messages/_form.html.erb.
export default class extends Controller {
  keydown(event) {
    // isComposing: Enter that confirms an IME composition (e.g. Japanese
    // input) isn't a send.
    if (event.key !== "Enter" || event.shiftKey || event.isComposing) return

    event.preventDefault()
    if (event.target.value.trim() === "") return
    this.element.requestSubmit()
  }
}
